// import React from "react";

const MobileView = () => {

    return("MobileView");
    
};

export default MobileView;